/* Draft-only: hide sticky preview while Teeinblue full Preview is open,
   zoom the complete Teeinblue composition, and use more mobile width. */
(() => {
  if (window.__pzStickyPreviewModalZoomV2) return;
  window.__pzStickyPreviewModalZoomV2 = true;

  const WRAPPER = '.grid__item.product__media-wrapper';
  const STICKY_GALLERY = `${WRAPPER} #tee-gallery`;
  const PREVIEW_BUTTON = '.tee-btn--preview';
  const BODY_OPEN_CLASS = 'pz-main-preview-open';

  let zoomFactor = 0.7;
  let mainPreviewSuppressed = false;
  let sawClosePreviewControl = false;
  let stateRaf = 0;
  let previewFallbackTimer = 0;

  const style = document.createElement('style');
  style.id = 'pz-sticky-preview-modal-zoom-v2';
  style.textContent = `
    body.${BODY_OPEN_CLASS} ${WRAPPER} .tee-gallery-content,
    body.${BODY_OPEN_CLASS} .sticky-gallery-mask,
    body.${BODY_OPEN_CLASS} .gallery--close-button,
    body.${BODY_OPEN_CLASS} .sticky-gallery-button,
    body.${BODY_OPEN_CLASS} .pz-sticky-zoom-controls {
      display: none !important;
    }

    body.gallery--sticky:not(.gallery--sticky--hide):not(.${BODY_OPEN_CLASS}) ${WRAPPER} .tee-gallery-content {
      padding: 10px 0 !important;
      align-items: flex-start !important;
    }

    body.gallery--sticky:not(.gallery--sticky--hide):not(.${BODY_OPEN_CLASS}) ${STICKY_GALLERY} {
      transform-origin: top center !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    .pz-sticky-zoom-controls {
      position: absolute !important;
      right: 14px !important;
      bottom: 14px !important;
      z-index: 1003 !important;
      display: none !important;
      align-items: center !important;
      gap: 7px !important;
      pointer-events: auto !important;
    }
    .pz-sticky-zoom-controls[data-pz-visible="true"] {
      display: flex !important;
    }
    .pz-sticky-zoom-controls button {
      display: grid !important;
      place-items: center !important;
      width: 40px !important;
      height: 40px !important;
      min-width: 40px !important;
      min-height: 40px !important;
      margin: 0 !important;
      padding: 0 0 2px !important;
      border: 1px solid rgba(33, 30, 42, .18) !important;
      border-radius: 50% !important;
      background: rgba(255, 255, 255, .97) !important;
      color: #211e2a !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .16) !important;
      font: 700 25px/1 Arial, sans-serif !important;
      cursor: pointer !important;
      touch-action: manipulation !important;
      -webkit-tap-highlight-color: transparent !important;
    }
  `;
  (document.head || document.documentElement).appendChild(style);

  const isStickyActive = () =>
    document.body.classList.contains('gallery--sticky') &&
    !document.body.classList.contains('gallery--sticky--hide') &&
    !document.body.classList.contains(BODY_OPEN_CLASS);

  const getBaseScale = (gallery) => {
    if (!gallery) return 0.9;
    const layoutWidth = gallery.offsetWidth || gallery.getBoundingClientRect().width || 0;
    if (!layoutWidth) return 0.9;

    // Fill almost all of the mobile viewport while keeping a small safe margin.
    const targetWidth = Math.max(280, Math.min(window.innerWidth - 24, window.innerWidth * 0.96));
    return Math.max(0.72, Math.min(1, targetWidth / layoutWidth));
  };

  const applyZoom = () => {
    const gallery = document.querySelector(STICKY_GALLERY);
    if (!gallery) return;

    if (isStickyActive()) {
      const baseScale = getBaseScale(gallery);
      const scale = Math.round(baseScale * zoomFactor * 1000) / 1000;
      gallery.style.setProperty('transform', `scale(${scale})`, 'important');
      gallery.style.setProperty('transform-origin', 'top center', 'important');
    } else {
      gallery.style.removeProperty('transform');
      gallery.style.removeProperty('transform-origin');
    }
  };

  const ensureZoomControls = () => {
    const content = document.querySelector(`${WRAPPER} .tee-gallery-content`);
    if (!content) return null;

    let controls = content.querySelector(':scope > .pz-sticky-zoom-controls');
    if (controls) return controls;

    controls = document.createElement('div');
    controls.className = 'pz-sticky-zoom-controls';
    controls.setAttribute('aria-label', 'Sticky preview zoom controls');
    controls.dataset.pzVisible = 'false';

    const minus = document.createElement('button');
    minus.type = 'button';
    minus.textContent = '−';
    minus.setAttribute('aria-label', 'Zoom out sticky preview');

    const plus = document.createElement('button');
    plus.type = 'button';
    plus.textContent = '+';
    plus.setAttribute('aria-label', 'Zoom in sticky preview');

    minus.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      zoomFactor = Math.max(0.7, Math.round((zoomFactor - 0.12) * 100) / 100);
      applyZoom();
    });

    plus.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      zoomFactor = Math.min(1.45, Math.round((zoomFactor + 0.12) * 100) / 100);
      applyZoom();
    });

    controls.append(minus, plus);
    content.appendChild(controls);
    return controls;
  };

  const controlText = (node) =>
    (node?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const findVisibleClosePreviewControl = () => {
    const controls = document.querySelectorAll('button, [role="button"], a');
    return Array.from(controls).find((control) => {
      const text = controlText(control);
      const aria = (control.getAttribute('aria-label') || '').trim().toLowerCase();
      if (text !== 'close preview' && !aria.includes('close preview')) return false;
      const rect = control.getBoundingClientRect();
      const css = window.getComputedStyle(control);
      return rect.width > 0 && rect.height > 0 && css.display !== 'none' && css.visibility !== 'hidden';
    }) || null;
  };

  const setMainPreviewSuppressed = (suppressed) => {
    mainPreviewSuppressed = suppressed;
    document.body.classList.toggle(BODY_OPEN_CLASS, suppressed);
    if (!suppressed) {
      sawClosePreviewControl = false;
      if (previewFallbackTimer) {
        window.clearTimeout(previewFallbackTimer);
        previewFallbackTimer = 0;
      }
    }
    syncState();
  };

  const looksLikeTeeClose = (target) => {
    const control = target?.closest?.('button, [role="button"], a, [class*="close"], [class*="Close"]');
    if (!control) return false;
    if (control.closest('.pz-sticky-zoom-controls, .gallery--close-button, .sticky-gallery-button')) return false;

    const text = controlText(control);
    const aria = (control.getAttribute?.('aria-label') || '').trim().toLowerCase();
    if (text === 'close preview' || aria.includes('close preview')) return true;

    const isSimpleClose = text === '×' || text === 'x' || aria === 'close' || aria === 'close preview';
    const teeContext = Boolean(control.closest('[class*="tee"], [id*="tee"]'));
    return isSimpleClose && teeContext;
  };

  const syncState = () => {
    const controls = ensureZoomControls();
    const visible = isStickyActive();

    if (controls) controls.dataset.pzVisible = visible ? 'true' : 'false';
    applyZoom();

    if (mainPreviewSuppressed) {
      const closePreview = findVisibleClosePreviewControl();
      if (closePreview) {
        sawClosePreviewControl = true;
      } else if (sawClosePreviewControl) {
        setMainPreviewSuppressed(false);
      }
    }
  };

  const scheduleState = () => {
    if (stateRaf) return;
    stateRaf = requestAnimationFrame(() => {
      stateRaf = 0;
      syncState();
    });
  };

  document.addEventListener('click', (event) => {
    if (event.target?.closest?.(PREVIEW_BUTTON)) {
      sawClosePreviewControl = false;
      setMainPreviewSuppressed(true);

      if (previewFallbackTimer) window.clearTimeout(previewFallbackTimer);
      previewFallbackTimer = window.setTimeout(() => {
        if (mainPreviewSuppressed && !sawClosePreviewControl && !findVisibleClosePreviewControl()) {
          setMainPreviewSuppressed(false);
        }
      }, 1200);
      return;
    }

    if (mainPreviewSuppressed && looksLikeTeeClose(event.target)) {
      window.setTimeout(() => setMainPreviewSuppressed(false), 60);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (mainPreviewSuppressed && event.key === 'Escape') {
      window.setTimeout(() => setMainPreviewSuppressed(false), 60);
    }
  }, true);

  window.addEventListener('scroll', scheduleState, { passive: true });
  window.addEventListener('resize', scheduleState, { passive: true });
  window.addEventListener('pageshow', scheduleState);

  new MutationObserver(scheduleState).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    childList: true,
    subtree: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncState, { once: true });
  } else {
    syncState();
  }

  window.setTimeout(syncState, 300);
  window.setTimeout(syncState, 1200);
})();
